 document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.sec-padding-narrow-full');
    const counters = document.querySelectorAll('.counter-title');

    // Intersection Observer to trigger on scroll
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          counters.forEach((counter) => {
            const target = parseInt(counter.textContent) || 0;
            let current = 0;
            const steps = 100; // Number of steps for 2-second animation
            const increment = target / steps;
            const unit = counter.textContent.match(/[+%]$/) ? counter.textContent.match(/[+%]$/)[0] : '';
            counter.textContent = '0'; // Start at 0

            const interval = setInterval(() => {
              current += increment;
              if (current < target) {
                counter.textContent = Math.floor(current) + unit;
              } else {
                clearInterval(interval);
                counter.textContent = target + unit;
              }
            }, 1000 / steps); // 20ms per step for 2 seconds total
          });
          observer.unobserve(section); // Stop after first trigger
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(section);
  });